// reducer.js
import {
  SET_VALUE_DOCS,
  SET_CATEGORIE_DOCS,
  SET_TYPE_DOCS,
  SET_CURRENT_PAGE_DOCS,
  SET_ORDER_DOCS,
  SET_SORT_FIELD_DOCS,
  SET_ANNEE_DOCS,
} from "./actionsTypes";

const initialState = {
  value: "",
  categorie: "",
  type: "",
  annee: "",
  currentPage: 1,
  order: "desc",
  sortField: "cree_le",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_DOCS:
      return {
        ...state,
        value: action.payload,
      };
    case SET_TYPE_DOCS:
      return {
        ...state,
        type: action.payload,
      };
    case SET_CATEGORIE_DOCS:
      return {
        ...state,
        categorie: action.payload,
      };
    case SET_CURRENT_PAGE_DOCS:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_DOCS:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_DOCS:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ANNEE_DOCS:
      return {
        ...state,
        annee: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
